// import classes
import { alertClasses } from "@mui/material/Alert";
export default {
    defaultProps: {
        variant: "filled",
    },
    styleOverrides: {
        root: ({ theme }) => ({
            [`&.${alertClasses.filled}.${alertClasses.colorSuccess}`]: {
                color: theme.vars.palette.primary.contrastText,
                backgroundColor: theme.vars.palette.success.main,
            },
        }),
    },
};
